import { render, staticRenderFns } from "./_categoryId.vue?vue&type=template&id=a97114c6&"
import script from "./_categoryId.vue?vue&type=script&lang=js&"
export * from "./_categoryId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Products: require('/Users/eralpsoftwareweb/Desktop/Active Projects/Heocademy/Gökçe Özel/gokce-ozel-nuxt/components/Products/index.vue').default})
